export type NpNotificationPillProps = {
  children: string
}

export const NpNotificationPill = ({ children }: NpNotificationPillProps) => (
  <div className="bg-np-red flex size-5 items-center justify-center rounded-full text-xs font-medium whitespace-nowrap text-white">
    {children}
  </div>
)
